/**
 * Helper function to replace placeholders in texts
 * @param text - Text with placeholders in the format {{variableName}}
 * @param values - Object with values to replace
 * @returns Text with replaced values
 *
 * @example
 * replacePlaceholders("Hello {{name}}", { name: "John" }) // "Hello John"
 * replacePlaceholders("{{value}} to {{label}}", { value: 5, label: "stadiums" }) // "5 to stadiums"
 */
export function replacePlaceholders(
	text: string,
	values: Record<string, string | number>,
): string {
	return text.replace(/\{\{(\w+)\}\}/g, (match, key) => {
		const value = values[key];
		return value !== undefined ? String(value) : match;
	});
}
